<script lang="ts">
	import LandingPage from "#lib/LandingPage.svelte";
	import type { PageData } from "./$types";

	let { data }: { data: PageData } = $props();
</script>

<LandingPage page={data.page} />
